<template>
  <div class="k2Image">
    <a v-if="link" @click="handleLink()">
      <img :src="src" :height="this.height">
    </a>
    <div v-else>
      <img :src="src" :height="this.height"  @error="handleImageError">
    </div>
  </div>
</template>

<script>
import "./k2Image.scss"
import assets from "@/assets/assets";
export default {
  name: "K2Image",
  props:["src","height","link","onclick","errorImage"],
  data(){
    return{
      assets: assets
    }
  },
  methods:{
    handleLink(){
      this.$emit("onclick")
    },
    handleImageError(event) {
      if(this.errorImage){
        event.target.src = this.errorImage;
      }else{
        event.target.src = assets.image.empty;
      }
    }
  }
}
</script>